/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HomeNowResponse = {
    properties: {
        matchdays: {
            type: 'DateList',
            isRequired: true,
        },
        matchesNearest: {
            type: 'HomeMatchList',
            isRequired: true,
        },
        matchesBefore: {
            type: 'HomeMatchList',
            isRequired: true,
        },
        matchesAfter: {
            type: 'HomeMatchList',
            isRequired: true,
        },
        tournamentsNearest: {
            type: 'TournamentList',
            isRequired: true,
        },
        tournamentsBefore: {
            type: 'TournamentList',
            isRequired: true,
        },
        tournamentsAfter: {
            type: 'TournamentList',
            isRequired: true,
        },
    },
} as const;
